<div class="register-photo">
  <div class="form-container">
      <div class="image-holder"></div>
      <div class="form">
      <form method="post" action="{{urlSignup}}" >
          <h2 class="text-center">Tạo tài khoản</h2>
          <div class="form-group"><input class="form-control" type="fullname" name="fullname" required placeholder="Họ tên của bạn" /></div>
          <div class="form-group"><input class="form-control" type="email" name="email" required placeholder="Email đăng ký" /></div>
          <div class="form-group"><input class="form-control" type="password" name="password" required placeholder="Mật khẩu đăng nhập" /></div>
          <div class="form-group"><input class="form-control" type="phone" name="phone" required placeholder="Số điện thoại của bạn" /></div>

          <!--<div class="form-group"><button class="btn btn-primary btn-block" type="" (click)="onClickSignUp()">Hoàn thành</button></div>-->
          <div class="form-group"><button class="btn btn-primary btn-block" type="submit" >Hoàn thành</button></div>

          <div><p class="center-or"> <span>Hoặc</span> </p></div>
          <a class="already" href="#">Đăng ký nhanh bằng tài khoản.</a>
          <!--<div class="d-flex justify-content-center mb-4">
            <a href="{{urlGoogleLogin}}" class="login-social-btn lift">
              <div class="google-button">
                <img class="icon-google" src="assets/images/icons/icon-google.png">
                Login with Google
              </div>
            </a>
        </div> -->
      </form>
        <div class="d-flex justify-content-center mb-4">
          <button class="btn btn-outline-success btn-google btn-block mb-3 " (click)="goToLink()">
            <span class="icon-google1 mb-1"></span>
            <span style="color: black;"> Google</span>
          </button>
        </div>

    </div>
  </div>
</div>
